import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { Button } from 'foundations-components/transitional/components/Button';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import Raven from 'raven-js';
import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function AsyncComponentLoading({
  bundleName,
  error,
  pastDelay,
  retry,
  useSpinner,
  navMarkerErrorName
}) {
  const [retriesLeft, setRetriesLeft] = useState(2);
  const handleRetry = () => {
    if (retriesLeft > 0) {
      retry === null || retry === void 0 || retry();
      setRetriesLeft(prev => prev - 1);
      return;
    }
    Raven.captureException(new Error(`Bundle: ${bundleName} All retries exhausted`), {
      extra: {
        error: typeof error === 'object' && error !== null ? error.responseJSON || error.message : error
      }
    });
    setTimeout(() => window.location.reload(), 250);
  };
  if (error) {
    const body = /*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.asyncComponent.errorTitle"
        })
      }), /*#__PURE__*/_jsx(Text, {
        as: "p",
        textAlign: "center",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.asyncComponent.error"
        })
      }), /*#__PURE__*/_jsx(Button, {
        onClick: handleRetry,
        use: "primary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "email-management.asyncComponent.reload"
        })
      })]
    });
    if (navMarkerErrorName) {
      return /*#__PURE__*/_jsx(NavMarker, {
        name: navMarkerErrorName,
        children: body
      });
    }
    return body;
  }
  if (pastDelay) {
    if (useSpinner) {
      return /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        flexDirection: "column",
        children: /*#__PURE__*/_jsx(LoadingSpinner, {
          marginBlockStart: "500",
          grow: true
        })
      });
    }
    return null;
  }
  return null;
}